import { computed, nextTick, reactive } from 'vue';
import mitt from 'mitt';
import { PrintState } from '@/types/interface/Print.interface';
import { addOverflow, removeOverflow } from '@/utils/body-overflow';

const print = reactive<PrintState>({
  content: null,
  togglePrint: computed(() => !!print.content),
  emitter: mitt(),
});

print.emitter.on('print', async (component) => {
  print.content = component.outerHTML;
  addOverflow();
  await nextTick();
  window.print();
});

window.addEventListener('afterprint', () => {
  print.content = null;
  removeOverflow();
});

export default () => ({
  print,
});
